// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"154":"cb71685f","236":"3737a539","238":"31af98bd","240":"b3131847","256":"7f087c04","267":"10d5a590","294":"c199e9d9","297":"e6e69a7f","311":"9662a91c","450":"d0bf4d05","536":"16e6da54","777":"0d7355dd"}[chunkId] + ".chunk.js";
};